import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import CargoTypeChart from '../charts/CargoTypeChart';
import NavigationTypeChart from '../charts/NavigationTypeChart';
import { Package, Waves, Ship } from 'lucide-react';

export default function CargoCharts() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Análise da Movimentação de Cargas</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Visão detalhada sobre os tipos de carga e as modalidades de navegação que impulsionam o setor.
          </p>
        </div>
        <div className="grid lg:grid-cols-2 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Movimentação por Tipo de Carga</h3>
            <CargoTypeChart />
             <Card className="mt-6 bg-white/80">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg"><Package className="w-5 h-5 text-blue-600" /> Destaques</CardTitle>
              </CardHeader>
              <CardContent className="text-gray-700 space-y-2 text-sm">
                <p>O **granel sólido não agrícola** (ex: minério de ferro) e o **granel líquido** (ex: petróleo) continuam sendo a base da matriz portuária, somando 65% do total.</p>
                <p>O destaque de 2024 foi a **carga conteinerizada**, que cresceu 20%, indicando um aumento no transporte de produtos de maior valor agregado e uma possível reindustrialização.</p>
              </CardContent>
            </Card>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Movimentação por Tipo de Navegação</h3>
            <NavigationTypeChart />
             <Card className="mt-6 bg-white/80">
               <CardHeader>
                 <CardTitle className="flex items-center gap-2 text-lg"><Waves className="w-5 h-5 text-cyan-600" /> Destaques</CardTitle>
              </CardHeader>
              <CardContent className="text-gray-700 space-y-2 text-sm">
                <p>A **navegação de longo curso** (internacional) domina com mais de 70% do volume, reafirmando o papel do Brasil como grande exportador global.</p>
                <p>A **cabotagem** (entre portos brasileiros) e a **navegação interior** (rios) vêm ganhando espaço de forma consistente. A navegação interior, em especial, teve a maior taxa de crescimento médio anual (+3,7%), impulsionada pelo agronegócio.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}